export default function AboutSection() {
  const stats = [
    { number: '18+', label: '년 경력' },
    { number: '200+', label: '프로젝트' },
    { number: '98%', label: '고객 만족도' },
    { number: '50+', label: '전문 인력' },
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div data-aos="fade-right">
            <p className="text-primary text-sm font-semibold tracking-wider uppercase mb-3">
              About Us
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-secondary mb-6 font-display">
              "다같이"<br />잘벌고! 잘먹고! 잘살자!<br />한성汗成
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              한성汗성은 부동산 분양대행, 투자자문, 개발사업, 자산관리 등 다양한 부동산 서비스를 제공하는 전문 기업입니다. 사람과 신뢰를 바탕으로 도전과 창조의 정신으로 고객과 함께 성장하고 있습니다.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              우리는 전문성과 신뢰를 바탕으로 고객의 성공적인 부동산 투자와 개발을 지원하며, 지속 가능한 가치 창출을 통해 더 나은 미래를 만들어갑니다.
            </p>
            
            <div className="grid grid-cols-2 gap-6 mb-8">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="text-center p-6 bg-white rounded-lg shadow-md"
                >
                  <div className="text-3xl font-bold text-primary mb-2 font-display">
                    {stat.number}
                  </div>
                  <div className="text-sm text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full">
                  <i className="ri-award-line text-xl text-primary"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-secondary">전문성</div>
                  <div className="text-xs text-gray-600">검증된 전문가</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full">
                  <i className="ri-shield-check-line text-xl text-primary"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-secondary">신뢰성</div>
                  <div className="text-xs text-gray-600">투명한 거래</div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-full">
                  <i className="ri-customer-service-line text-xl text-primary"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-secondary">고객중심</div>
                  <div className="text-xs text-gray-600">맞춤형 서비스</div>
                </div>
              </div>
            </div>
          </div>

          <div data-aos="fade-left" className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://www.whizcompany.com/images/main/main.mp4"
                alt="About Whiz Company"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) {
                    parent.style.background = 'linear-gradient(135deg, #C8A882 0%, #8B7355 100%)';
                    parent.style.minHeight = '500px';
                  }
                }}
              />
              <div 
                className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"
                style={{
                  backgroundImage: 'url(https://static.readdy.ai/image/0adaafd12e96644bb3f30378f0b23f95/4b1d3f3154e21c2a46958f3b40783f12.png)',
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}
              ></div>
            </div>
            
            <div className="absolute -bottom-8 -left-8 bg-primary text-white p-8 rounded-lg shadow-xl">
              <div className="text-4xl font-bold mb-2 font-display">18+</div>
              <div className="text-sm">Years of Excellence</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
